import { FormattedMessage, useIntl } from 'react-intl';
import { toast } from '@/hooks/useToast';
import { useDeleteAllpayUser } from '@/api/trafikportalen';
import Button from '../core/Button';
import { IconTrash } from '@/icons';
import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';

interface Props {
  allpayUserID: string;
  onOpenChange: (open: boolean) => void;
}

export const AllpayUserDeleteForm = ({ allpayUserID, onOpenChange }: Props) => {
  const { formatMessage } = useIntl();
  const queryClient = useQueryClient();
  const deleteAllpayUser = useDeleteAllpayUser();

  const handleDelete = useCallback(() => {
    deleteAllpayUser.mutate(
      {
        id: allpayUserID,
      },
      {
        onSuccess: async () => {
          toast.success(
            {
              title: formatMessage({
                defaultMessage: `Tjänsteresekredit borttagen`,
              }),
            },
            { autoClose: 3000 },
          );
          await queryClient.invalidateQueries({
            queryKey: ['/allpay-users'],
          });
          onOpenChange(false);
        },
        onError: (error) => {
          console.error('Error', error);
          toast.error(
            {
              title: formatMessage({ defaultMessage: 'Ett fel inträffade' }),
            },
            { autoClose: 3000 },
          );
        },
      },
    );
  }, [
    allpayUserID,
    deleteAllpayUser,
    formatMessage,
    onOpenChange,
    queryClient,
  ]);

  return (
    <div>
      <p>
        <FormattedMessage defaultMessage="Är du säker på att du vill radera tjänsteresekrediten för denna avdelning?" />
      </p>
      <div className="mt-4 flex justify-end gap-2">
        <Button variant="ghost" onClick={() => onOpenChange(false)}>
          <FormattedMessage defaultMessage="Avbryt" />
        </Button>
        <Button
          color="red"
          type="submit"
          variant="filled"
          startIcon={<IconTrash />}
          onClick={handleDelete}
          loading={deleteAllpayUser.isPending}
        >
          <FormattedMessage defaultMessage="Radera" />
        </Button>
      </div>
    </div>
  );
};
